export default __webpack_public_path__ + "static/media/08_masterf 1.5d28a894.svg";